module.exports = {
  methods: {
    cdn(path) {
      return this.$page.props.cdn_url + path
    },
    resetFlashMessages() {
      if (this.$page && this.$page.props) {
        this.$page.props.flash = {}
        this.$page.props.errors = {}
      }
    },
  },
}
